import { FC, useState } from "react";
import { Abonnement } from "../../lib/interfaces/abonnement.interface";
import { useQuery } from "@tanstack/react-query";
import { ksAllowReabonnementQK } from "../../lib/query-keys";
import { allowReabonnement } from "../../lib/queries/abonnement-queries";
import { Link } from "react-router-dom";
import { Button } from "../ui/button";
import { formatDate } from "../../lib/helpers/date_helpers";
import { PlusCircle } from "lucide-react";
import AugmenterCheptelDialog from "../dialogs/AugmenterCheptelDialog";

interface Props {
  abonnement: Abonnement | null;
}

const BlocAbonnement: FC<Props> = ({ abonnement: abo }) => {
  const [showAugmenterCheptelDialog, setShowAugmenterCheptelDialog] = useState(false);
  const { data: canReabo } = useQuery({
    queryKey: [ksAllowReabonnementQK],
    queryFn: allowReabonnement,
  });
  const isViaStructure = abo?.type === "A" || abo?.type === "N" || abo?.type === "EN";

  return (
    <>
      <div className='pt-3'>
        {/* Abonnement */}
        {!!abo && (
          <div className='flex flex-col gap-2'>
            {!abo.actif && (
              <div className='text-red-700 font-medium text-sm px-5 py-1 rounded-lg bg-red-200 w-min'>Inactif</div>
            )}
            {abo.syndicat && <div>Vous êtes abonné(e) via le syndicat : {abo.syndicat?.nom}</div>}
            <div>
              <div className='flex flex-row gap-3 text-gray-800 mb-0.5'>
                <div className='font-semibold'>Type d'abonnement :</div>{" "}
                {abo.revue ? "Papier + numérique" : "Numérique"}
              </div>
              <div className='flex flex-row gap-3 text-gray-800 mb-0.5'>
                <div className='font-semibold'>Date de début :</div> {formatDate(abo.dateDebut)}
              </div>
              <div className='flex flex-row gap-3  text-gray-800 '>
                <div className='font-semibold'>Date de fin :</div> {formatDate(abo.dateFin)}
              </div>
              {!abo.isV2 && (
                <div className='flex flex-row gap-3 text-gray-800'>
                  <div className='font-semibold'>Éco-contribution incluse :</div> {abo.citeo ? "Oui" : "Non"}
                </div>
              )}
              {abo.isV2 && (
                <>
                  <div className='flex flex-col md:flex-row md:gap-3 text-gray-800 md:items-center'>
                    <div className='font-semibold'>Formule souscrite :</div>{" "}
                    {!!abo.pack ? (
                      <div className='flex flex-col md:flex-row md:gap-2 md:items-center'>
                        <div>
                          {abo.pack.nom} pour <strong>{abo.ruches}</strong> ruche
                          {abo.ruches === 1 ? "" : "s"}
                        </div>
                        {abo.actif && abo.type !== "EN" && abo.type !== "A" && abo.type !== "N" && !canReabo && (
                          <div>
                            <button
                              className='text-sm font-medium py-1 px-3 rounded bg-purple-700 text-white flex gap-2 items-center duration-150 hover:bg-purple-800'
                              onClick={() => setShowAugmenterCheptelDialog(true)}
                            >
                              <PlusCircle className='w-4 h-4' /> Augmenter le cheptel assuré
                            </button>
                          </div>
                        )}
                      </div>
                    ) : (
                      "Aucune"
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        )}

        {/* Cas d'un direct qui peut se réabonner */}
        {canReabo === true && !isViaStructure && !!abo && (
          <div className='mt-3'>
            <Link to='/sabonner'>
              <Button>Programmer son réabonnement</Button>
            </Link>
          </div>
        )}
        {/* Pas d'abonnement */}
        {!abo && (
          <div className='flex flex-col gap-4'>
            <div>Vous n'êtes pas abonné(e) à l'Abeille de France actuellement.</div>
            <div>
              <Link to='/sabonner'>
                <Button>S'abonner</Button>
              </Link>
            </div>
          </div>
        )}
      </div>

      {!!abo && !!abo.pack && (
        <AugmenterCheptelDialog
          abonnement={abo}
          setOpen={setShowAugmenterCheptelDialog}
          open={showAugmenterCheptelDialog}
        />
      )}
    </>
  );
};

export default BlocAbonnement;
